import moment from 'moment';
export const formatDateWithTime = (date: string) => {
    return moment(date).format('DD-MM-YYYY h:mma')
};
export const formatDateWithTimeFlatpickr = (date: string) => {
    return moment(date).format('YYYY/MM/DD h:mma')
};
export const formatDateWithoutTime = (date: string) => {
    return moment(date).format('DD-MM-YYYY')
};
export const formatDate = (date: string) => {
    return moment(date).format('YYYY/MM/DD')
};
/**
 * Formats a Date object into a readable time string (e.g., "14:35:10")
 */
export const formatTime = (date: Date | null): string => {
    if (!date) return 'N/A';
    // Ensure it's a valid Date object before formatting
    if (isNaN(date.getTime())) return 'Invalid Date'; 
    return date.toLocaleTimeString();
  };
  /**
 * Formats duration in milliseconds into HH:MM:SS format
 */  
export const formatDuration = (durationMs: number): string => {
    if (isNaN(durationMs) || durationMs < 0) durationMs = 0; // Ensure duration is valid and not negative
  
    const totalSeconds = Math.floor(durationMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    // Pad with leading zeros if necessary
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');
  
    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
  };
export const formatDateAttendance = (date) => {
    return moment(date).format('YYYY/MM/DD')
};
export const formatDateMyAttendance = (date) => {
    return moment(date).format('DD/MM/YYYY')
};
export const formatDateWithTimeAttendance = (date) => {
    return moment(date).format('DD/MM/YYYY h:mma')
};
export const formatDatePickr = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
export const formatDateWithTime24h = (date: string | Date) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
};
export const formatDateOnly = (date: string | Date) => {
    return moment(date).format('YYYY-MM-DD');
};